import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { CurrencyFormats, Vehicle } from '@sm360/widget-commons-vehicle';

import 'vdp-used/components/PhotosAndBodyAndCertifiedSection/BodyAndFuel/BodyAndFuel.scss';

const BodyAndFuel = ({ vehicle }) => {
    return (
        <div className="showroom-vdp-used-features-vehicle-info-wrapper">
            <div className="showroom-vdp-used-features-vehicle-info">
                <icon className="icon-passenger">&nbsp;</icon>
                <p className="showroom-vdp-used-features-vehicle-info-title">
                    {LocaleService.t('VEHICLE_BODY_AND_FUEL.SEATING')}
                </p>
                <p className="showroom-vdp-used-features-vehicle-info-value">
                    {vehicle.seating > 0 ? vehicle.seating : ''}
                </p>
            </div>
            <div className="showroom-vdp-used-features-vehicle-info">
                <icon className="icon-doors">&nbsp;</icon>
                <p className="showroom-vdp-used-features-vehicle-info-title">
                    {LocaleService.t('VEHICLE_BODY_AND_FUEL.DOORS')}
                </p>
                <p className="showroom-vdp-used-features-vehicle-info-value">
                    {vehicle.doors > 0 ? vehicle.doors : ''}
                </p>
            </div>
            <div className="showroom-vdp-used-features-vehicle-info">
                <icon className="icon-bodystyle">&nbsp;</icon>
                <p className="showroom-vdp-used-features-vehicle-info-title">
                    {LocaleService.t('VEHICLE_BODY_AND_FUEL.BODY_STYLE')}
                </p>
                <p className="showroom-vdp-used-features-vehicle-info-value">{vehicle.bodyStyle?.name}</p>
            </div>
            <div className="showroom-vdp-used-features-vehicle-info">
                <icon className="icon-fuel">&nbsp;</icon>
                <p className="showroom-vdp-used-features-vehicle-info-title">
                    {LocaleService.t('VEHICLE_BODY_AND_FUEL.FUEL')}
                </p>
                <p className="showroom-vdp-used-features-vehicle-info-value">{vehicle.fuel?.name}</p>
                <div className="showroom-vdp-used-features-vehicle-info-fuel-wrapper">
                    <div className="showroom-vdp-used-features-vehicle-info-fuel">
                        <p className="showroom-vdp-used-features-vehicle-info-fuel-value is-price">
                            {vehicle?.getConsumptionInCity() > 0
                                ? LocaleService.l(vehicle?.getConsumptionInCity(), CurrencyFormats.FUEL_CONSUMPTION)
                                : 'N/A'}
                        </p>
                        <p className="showroom-vdp-used-features-vehicle-info-fuel-name">
                            {LocaleService.t('VEHICLE_BODY_AND_FUEL.CITY')}
                        </p>
                    </div>
                    <div className="showroom-vdp-used-features-vehicle-info-fuel">
                        <p className="showroom-vdp-used-features-vehicle-info-fuel-value is-price">
                            {vehicle?.getConsumptionOnHighway() > 0
                                ? LocaleService.l(vehicle?.getConsumptionOnHighway(), CurrencyFormats.FUEL_CONSUMPTION)
                                : 'N/A'}
                        </p>
                        <p className="showroom-vdp-used-features-vehicle-info-fuel-name">
                            {LocaleService.t('VEHICLE_BODY_AND_FUEL.HIGHWAY')}
                        </p>
                    </div>
                </div>
                <p className="showroom-vdp-used-features-vehicle-info-fuel-info">
                    {LocaleService.t('VEHICLE_BODY_AND_FUEL.L_100KM')}
                </p>
            </div>
        </div>
    );
};

BodyAndFuel.propTypes = {
    vehicle: PropTypes.instanceOf(Vehicle.VehicleModelV25).isRequired,
};

BodyAndFuel.displayName = 'BodyAndFuel';

export default BodyAndFuel;
